import { RELICS } from './relics';
import { getPhaseAnchorState } from './phaseAnchor';
import { getChainReactionState } from './chainReaction';
import { getBountyTagState } from './bountyTag';
import { getGhostBumpState } from './ghostBump';
import { getDecoyBeaconState } from './decoyBeacon';
import { CORE_SECTOR } from './runConstants';

export const getRelicAbilities = (game, context = 'setup') => {
  const core = game.floor === CORE_SECTOR && context !== 'survival';
  const floorLimit = core ? 'Core fight' : 'floor';
  const anchor = getPhaseAnchorState(game);
  const chain = getChainReactionState(game);
  const bounty = getBountyTagState(game);
  const ghost = getGhostBumpState(game);
  const beacon = getDecoyBeaconState(game);
  const entries = [
    {
      id: 'phaseAnchor',
      shortName: 'Anchor',
      used: anchor.used,
      armed: anchor.armed,
      status: anchor.used ? 'Used' : 'Ready',
      limit: floorLimit,
    },
    {
      id: 'chainReaction',
      shortName: 'Chain',
      used: chain.used,
      armed: chain.armed,
      status: chain.used ? 'Used' : chain.armed ? 'Armed' : 'Ready',
      limit: 'run',
    },
    ...(!core && context !== 'survival'
      ? [
          {
            id: 'bountyTag',
            shortName: 'Bounty',
            armed: bounty.armed,
            status: bounty.armed ? 'Marked' : 'Ready',
            limit: 'room',
          },
        ]
      : []),
    ...(core
      ? [
          {
            id: 'ghostBump',
            shortName: 'Ghost Bump',
            used: ghost.used,
            armed: ghost.armed,
            status: ghost.used ? 'Used' : 'Ready',
            limit: 'Core fight',
          },
          {
            id: 'decoyBeacon',
            shortName: 'Decoy',
            used: beacon.used,
            armed: beacon.deployed,
            status:
              beacon.used ? 'Used' : beacon.deployed ? 'Deployed' : 'Ready',
            limit: 'Core fight',
          },
        ]
      : []),
    {
      id: 'mirrorChip',
      shortName: 'Mirror',
      used: !!game.floorFlipUsed,
      reactive: true,
      limit: floorLimit,
    },
    ...(context !== 'survival'
      ? [
          {
            id: 'lastStandProtocol',
            shortName: 'Last Stand',
            used: !!game.lastStandProtocol?.used,
            reactive: true,
            limit: 'run',
          },
        ]
      : []),
  ];
  return entries
    .filter(
      ({ id }) =>
        game.relics?.includes(id) &&
        (context !== 'warning' || ['ghostBump', 'decoyBeacon'].includes(id))
    )
    .map((entry) => ({
      ...entry,
      name: RELICS[entry.id].name,
      icon: RELICS[entry.id].icon,
      rarity: RELICS[entry.id].category || RELICS[entry.id].rarity,
      remaining: entry.used ? 0 : 1,
      status:
        entry.status ||
        (entry.used
          ? 'Used'
          : entry.armed
          ? 'Queued'
          : entry.partial
          ? 'Setup'
          : 'Ready'),
    }));
};
